export default "__VITE_ASSET__5ea9a5e1__"